<template>
  <field-info
    :type="fieldCode"
  />
</template>

<script>
import FieldInfo from "@/views/fields/template/FieldInfo.vue";

export default {
  components: {
    FieldInfo,
  },
  data() {
    return {
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    fieldCode() {
      return this.$route.params.fieldCode;
    },
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
</style>
